import { useState } from "preact/hooks";

import { t } from "../i18n";
import { userLocation } from "../state";

export function LocateMeButton() {
  const [error, setError] = useState<string | null>(null);

  const onClick = () => {
    setError(null);
    if (!("geolocation" in navigator)) {
      setError(t("no_location_permission"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        userLocation.value = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
      },
      () => {
        setError(t("no_location_permission"));
      },
      { timeout: 10000, enableHighAccuracy: false },
    );
  };

  return (
    <button
      type="button"
      class="header-btn"
      onClick={onClick}
      title={t("locate_me")}
      aria-label={t("locate_me")}
    >
      📍
      {error && <span class="header-btn__error">{error}</span>}
    </button>
  );
}
